import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-edit",
  "use": "icon-edit-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-edit\"><path d=\"M1 15h14v-1.167H1V15Zm2.333-3.5V8.825l4.084-4.083 2.675 2.675L6.008 11.5H3.333ZM9.75 2.41l2.675 2.675-1.508 1.508-2.675-2.675L9.75 2.409Zm3.912 3.088h.001a.583.583 0 0 0 0-.826l-3.5-3.5a.583.583 0 0 0-.825 0h-.001l-7.17 7.171v4.325h4.325l7.17-7.17Z\" fill=\"#181818\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol